import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { ToasterCenter } from '../components/toaster/ToasterCenter';
import StatusModalContainer from '../containers/StatusModalContainer';
import { FundProvider } from '../contexts/FundContext';
import { InvestmentNoteProvider } from '../contexts/InvestmentNoteContext';
import { KnowledgeTestProvider } from '../contexts/KnowledgeTestContext';
import { LanguageProvider } from '../contexts/LanguageContext';
import { StatementProvider } from '../contexts/StatementContext';
import { StatusModalProvider } from '../contexts/StatusModalContext';
import FundModals from '../modules/fund/views/FundModals';
import StatementModals from '../modules/statement/views/StatementModals';
import Router from '../routes/Router';
import './App.scss';

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false,
        },
    },
});

function App() {
    return (
        <div className="App">
            <QueryClientProvider client={queryClient}>
                <LanguageProvider>
                    <FundProvider>
                        <StatementProvider>
                            <InvestmentNoteProvider>
                                <StatusModalProvider>
                                    <KnowledgeTestProvider>
                                        <FundModals />
                                        <StatusModalContainer />
                                        <StatementModals />
                                        <Router />
                                        <ToasterCenter />
                                    </KnowledgeTestProvider>
                                </StatusModalProvider>
                            </InvestmentNoteProvider>
                        </StatementProvider>
                    </FundProvider>
                </LanguageProvider>
            </QueryClientProvider>
        </div>
    );
}

export default App;
